import { Routes, Route } from "react-router-dom";
import Dashboard from "../components/pages/user/Dashboard/Dashboard";
import Campaigns from "../components/pages/user/Dashboard/Campaigns";
import HelpCenter from "../components/pages/user/Dashboard/HelpCenter";
import Transactions from "../components/pages/user/Dashboard/Transactions";
import AccountManagement from "../components/pages/user/Dashboard/AccountManagement";
import UserProtectedRoute from "../components/pages/user/ProtectRoutes";

import Login from "../components/pages/user/Login/Login";
import Register from "../components/pages/user/Register/Register";
import ResetPassword from "../components/pages/user/ResetPassword/ResetPassword";
import ResetPasswordForm from "../components/pages/user/ResetPassword/PasswordResetForm";
import VerifyEmailPage from "../components/pages/user/Register/VerifyEmail";
import ResendVerifyEmailPage from "../components/pages/user/Register/ResendVerifyEmailPage";












function UserRoutes() {
  return (
    <Routes>

    
      {/* Protected Routes */}
      <Route 
        path="/dashboard" 
        element={
          <UserProtectedRoute>
<Dashboard />
          </UserProtectedRoute>
        }
      />
      <Route 
        path="/help" 
        element={
          <UserProtectedRoute>
<HelpCenter />
          </UserProtectedRoute>
        }
      />
      <Route 
        path="/campaigns" 
        element={
          <UserProtectedRoute>
<Campaigns />
          </UserProtectedRoute>
        }
      />
      <Route 
        path="/transactions" 
        element={
          <UserProtectedRoute>
<Transactions />
          </UserProtectedRoute>
        }
      />
      <Route 
        path="/account" 
        element={
          <UserProtectedRoute>
<AccountManagement />
          </UserProtectedRoute>
        }
      />



     



      {/* Unprotected Routes */}
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot-password" element={<ResetPassword />} />
      <Route path="/password-reset" element={<ResetPasswordForm />} />
      <Route path="/verify-email" element={<VerifyEmailPage />} />
      <Route path="/resend-verify-email-link" element={<ResendVerifyEmailPage />} />




      

    </Routes>
  );
}

export default UserRoutes;
